import { render, staticRenderFns } from "./AppletsPage.vue?vue&type=template&id=7a9a8ab9&scoped=true"
import script from "./AppletsPage.vue?vue&type=script&lang=js"
export * from "./AppletsPage.vue?vue&type=script&lang=js"
import style0 from "./AppletsPage.vue?vue&type=style&index=0&id=7a9a8ab9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9a8ab9",
  null
  
)

export default component.exports